export const statusStyle = (status) => {
  const map = {
    Delivered:  { bg: "rgba(76,175,80,0.12)",   color: "#2e7d32" },
    Shipped:    { bg: "rgba(33,150,243,0.12)",   color: "#1565c0" },
    Processing: { bg: "rgba(255,152,0,0.12)",    color: "#e65100" },
    Pending:    { bg: "rgba(158,158,158,0.15)",  color: "#424242" },
    Cancelled:  { bg: "rgba(255,77,107,0.12)",   color: "#c62828" },
  };
  return map[status] || { bg: "#f5f5f5", color: "#333" };
};

export const paymentStyle = (status) => {
  const map = {
    Paid:     { bg: "rgba(76,175,80,0.12)",  color: "#2e7d32" },
    Pending:  { bg: "rgba(255,152,0,0.12)",  color: "#e65100" },
    Refunded: { bg: "rgba(255,77,107,0.12)", color: "#c62828" },
  };
  return map[status] || { bg: "#f5f5f5", color: "#333" };
};

